import { connect } from 'react-redux'

import { setActiveAudio } from '../../../common/actions/searchPage'
import { IRootState } from '../../../common/reducers'
import AudioPlayer, { ILength } from './audioPlayer'

interface IStateProps {
  isActive: boolean
  searchAudioVolumeLevel: number
  searchAudioMuted: boolean
}

interface IDispatchProps {
  onPlay: () => void
}

interface IOwnProps {
  id: number
  length: ILength
  src: string
  viewType: string
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const {
    searchPage: { activeAudio },
    user: {
      preferences: { searchAudioVolumeLevel, searchAudioMuted }
    }
  } = state

  const { src } = ownProps
  return {
    isActive: !!(src && src === activeAudio),
    searchAudioVolumeLevel,
    searchAudioMuted
  }
}

const mapDispatchToProps = (
  dispatch: any,
  ownProps: IOwnProps
): IDispatchProps => {
  const { src } = ownProps
  return {
    onPlay: () => dispatch(setActiveAudio(src))
  }
}

const AudioPlayerContainer = connect<IStateProps, IDispatchProps, IOwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(AudioPlayer)

export default AudioPlayerContainer
